import { useAblyTypedPubSub } from '../use-ably'
import { useAxios } from '@/contexts/AxiosProvider'
import { useHall } from '@/contexts/HallProvider'
import { HallUser } from '@db8/shared'
import { useCallback } from 'react'

const dedupeUsers = (users: any[]) => {
  const seen = new Set()
  return users.filter((user) => {
    const key = user.botId != null ? `bot-${user.botId}` : user.clerkId || user.id
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}

export const useHallUsersPubSub = ({
  hallUsers,
  setHallUsers,
}: {
  hallUsers: any[]
  setHallUsers: (val: any[]) => void
}) => {
  const { hall } = useHall()
  const axios = useAxios()

  const { publish, isFetching, hasSyncedOnce } = useAblyTypedPubSub<any[]>(
    'HALL-USERS',
    ({ data, sender }) => {
      const deduped = dedupeUsers(data)
      setHallUsers(deduped)
    },
    hall.id ? { url: `/api/hall/${hall.id}/hall-users` } : undefined,
  )

  const publishHallUsers = useCallback(
    async (users: HallUser[], opts?: { replace?: boolean }) => {
      const replace = opts?.replace ? 'true' : 'false'
      await axios.patch(`/api/hall/${hall?.id}/hall-users?replace=${replace}`, users)
    },
    [axios, hall?.id],
  )

  return { publishHallUsers, hallUsers, isFetching, hasSyncedOnce }
}
